import { db } from 'boot/firebase';
import { collection } from 'firebase/firestore';

import GenericDB from './generic-db';

export default class ProgramBehaviourDataItemsDB extends GenericDB {
  constructor(programId = null, programBehaviourDataGroupId = null) {
    super('', 'programs.programBehaviourDataGroups.programBehaviourDataItems');
    this.setProgramId(programId);
    this.setProgramBehaviourDataGroupId(programBehaviourDataGroupId);
  }

  setProgramId(programId) {
    this.programId = programId;
  }

  setProgramBehaviourDataGroupId(programBehaviourDataGroupId) {
    this.programBehaviourDataGroupId = programBehaviourDataGroupId;
  }

  getCollectionRef() {
    return collection(
      db,
      'programs',
      this.programId,
      'programBehaviourDataGroups',
      this.programBehaviourDataGroupId,
      'programBehaviourDataItems',
    );
  }
}
